import type {Nullish} from 'shared/web';

import {toBoundedAssistantInterestText} from './toBoundedAssistantInterestText';

const RAW_CATALOGUE_KEY_PATTERN = /(?:^|-)(?:MAKE|MODELFAMILY)_/;

export const toResolvedVehicleLabel = (value: string | Nullish) =>
  toBoundedAssistantInterestText(
    value
      ?.split(' ')
      .filter((part) => !RAW_CATALOGUE_KEY_PATTERN.test(part))
      .join(' ')
  );
